import {LOCALE_DEL_IDIOMA, etiquetasEn, idiomaDesde, textoEn, type Idioma} from '@cnc/contracts';

// Idioma activo de la interfaz. Vive en una variable del modulo porque al
// cambiarlo la aplicacion se vuelve a montar entera (ver proveedor-idioma.tsx):
// cualquier componente o funcion que se ejecute al dibujar lee el valor nuevo.
//
// Uso:
//   tr('Guardar', 'Save')                      texto en el idioma activo
//   et(ETIQUETA_ROL, ETIQUETA_ROL_EN)[rol]     etiqueta de los contratos
//   txt('Estado', 'Status') + trx(...)         para constantes del modulo, que
//                                              se evaluan antes de saber el idioma
let actual: Idioma = idiomaDelNavegador();

export function idiomaDelNavegador(): Idioma {
  return typeof navigator === 'undefined' ? 'es' : idiomaDesde(navigator.language);
}

export const idiomaActual = (): Idioma => actual;

export function fijarIdiomaActual(idioma: Idioma) {
  actual = idioma;
  if (typeof document !== 'undefined') document.documentElement.lang = idioma;
}

// En hindi el texto sale del ingles con el diccionario de los contratos.
export const tr = (es: string, en: string): string => textoEn(actual, es, en);

export type Texto = {es: string; en: string};
export const txt = (es: string, en: string): Texto => ({es, en});
export const trx = (texto: Texto | string): string =>
  typeof texto === 'string' ? texto : textoEn(actual, texto.es, texto.en);
// Llave estable de un texto (su version en espanol), para comparar o usar como key.
export const claveDeTexto = (texto: Texto | string): string => (typeof texto === 'string' ? texto : texto.es);

export const et = <K extends string, V>(es: Record<K, V>, en: Record<K, V>): Record<K, V> =>
  etiquetasEn(actual, es, en);

// Formato regional de numeros y fechas del idioma activo.
export const localeActual = () => LOCALE_DEL_IDIOMA[actual];
